module.exports = require('@frontend-metrics/hotjar');
